export default __webpack_public_path__ + "img/manila_wanderland_2023-a95819732c81c1dd475e6a5469e8286f.png";